import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ZkELowerCasedCountryCodes, ZkStripeService } from '@zenklub/ng-ui';
import { environment } from 'environments/environment';

import { IProfessionalProfile } from '../interfaces/professionalprofile.interface';

export enum StripeStatusEnum {
	ACTIVE = 'active',
	NO_CONNECTED = 'no-connected',
	IN_PROGRESS = 'in-progress',
}

@Injectable({
	providedIn: 'root',
})
export class StripeService extends ZkStripeService {
	private country: ZkELowerCasedCountryCodes = ZkELowerCasedCountryCodes.Brazil;
	private keys = environment.stripe.keys[this.country];
	publicKey = this.keys.publishableKey;
	readKey = this.keys.readkey;

	constructor(http: HttpClient) {
		super(http);
	}

	getStatus(userData: IProfessionalProfile): StripeStatusEnum {
		let status: StripeStatusEnum;
		if (
			!userData.stripeConnectedAccount ||
			(userData.stripeConnectedAccount && !userData.stripeDetailsSubmitted)
		) {
			status = StripeStatusEnum.NO_CONNECTED;
		} else if (
			userData.stripeConnectedAccount &&
			userData.stripeDetailsSubmitted &&
			!userData.stripePaymentOk
		) {
			status = StripeStatusEnum.IN_PROGRESS;
		} else if (
			userData.stripeConnectedAccount &&
			userData.stripeDetailsSubmitted &&
			userData.stripePaymentOk
		) {
			status = StripeStatusEnum.ACTIVE;
		}
		return status;
	}
}
